import React from "react";
import { Badge } from "@/components/ui/badge";

interface AttachmentSectionHeaderProps {
  title: string;
  count: number;
  /** Dokumentnummer i Bas-processen, t.ex. "11" */
  doc?: string;
  description?: string;
}

export const AttachmentSectionHeader: React.FC<AttachmentSectionHeaderProps> = ({
  title,
  count,
  doc,
  description,
}) => (
  <header className="flex flex-wrap items-center gap-3 rounded-lg border bg-muted/40 px-4 py-3">
    <h3 className="text-base font-semibold text-foreground">{title}</h3>
    <Badge variant="outline" className="text-[11px] font-medium">
      {doc ? `Bilaga · Dok ${doc}` : "Bilaga"}
    </Badge>
    <span className="text-xs text-muted-foreground">{count} st</span>
    {description && (
      <span className="text-xs text-muted-foreground ml-auto">{description}</span>
    )}
  </header>
);

export default AttachmentSectionHeader;
